import { hasValue } from './displayUtils.js';

export function readableDate(value, includeTime = true) {
	if (!hasValue(value)) return null;

	const dateValue = typeof value === 'string' ? value.trim() : value;
	const hasTimezone = typeof dateValue === 'string' && /(?:Z|[+-]\d{2}:?\d{2})$/i.test(dateValue);
	const isDateOnly = typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue);
	const utcValue = typeof dateValue === 'string' && !hasTimezone && !isDateOnly
		? `${dateValue.replace(' ', 'T')}Z`
		: dateValue;
	const date = new Date(utcValue);

	if (Number.isNaN(date.getTime())) return value;

	const options = includeTime
		? {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: '2-digit',
			timeZone: 'UTC',
			timeZoneName: 'short',
		}
		: {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			timeZone: 'UTC',
		};

	return new Intl.DateTimeFormat('en-US', options).format(date);
}
